<template>
  <div class="container">
    <div class="main">
      <div class="title" > DIXCEL中国10周年logo发布！ </div>
      <div style="color :gray;font-size :14px;text-align:center;margin-bottom:20px">2021-03-01</div>

      <div style="width:50%;margin:0 auto;margin-bottom:20px;margin-top:20px">
        <el-image
          style="width:100%;margin-bottom:20px"
          :src="require('@/assets/image/moment/newsActivitiesPage/2021_03_01/img1.png')"
          fit="fit">
        </el-image>
      </div>

      <div style="line-height:30px">
        <div style="text-indent:30px"> 2011年，DIXCEL中国在上海正式成立。作为日本株式会社DIXCEL（现DJHOLDINGS GROUP）的全资子公司，DIXCEL中国秉承了日本本社“服务客户、满足客户”的精神，获得了广大客户的支持与信赖。

借10周年庆之际，我们将推出“DIXCEL中国10周年庆”系列活动以感谢新老客户的厚爱。“DIXCEL中国10周年”logo将出现在正规行货产品的包装盒、官方网站（新版）、ONLINE经销商采购平台等媒介上。另外，“DIXCEL中国10周年庆”周边产品也将陆续推出，敬请期待！ </div>  
      </div>


      

    </div>
  </div>
</template>


<script>
    export default {
      data() {
        return{

        }
      }
    }
  </script>

<style lang="stylus" scoped>


.container
  background-color : #000
  .box_one 
    width: 100%;

  .box_bottom
    width: 100%;
    background-color #000


.main {
  margin-bottom: 5px;
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding: 62px 50px 52px;
}
  .title {
    color :#ab191d;
    text-align:center;
    margin-bottom 10px
  }


</style>